// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.parameter
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.model.autopay.AutoPay
import org.mifospay.core.model.autopay.AutoPayHistory
import org.mifospay.core.model.autopay.AutoPayPayload
import org.mifospay.core.model.autopay.AutoPayTemplate
import org.mifospay.core.model.autopay.AutoPayUpdatePayload
import org.mifospay.core.model.autopay.UpcomingPayment
import org.mifospay.core.network.model.entity.Page

@OptIn(InternalKtorfitApi::class)
public class _AutoPayServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : AutoPayService {
  override fun getAutoPayTemplate(clientId: Long, sourceAccountId: Long): Flow<AutoPayTemplate> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "autopay/template")
        clientId?.let{ parameter("clientId", "$it") }
        sourceAccountId?.let{ parameter("sourceAccountId", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<AutoPayTemplate>>(),)!! 
  }

  override fun getAllAutoPaySchedules(clientId: Long): Flow<List<AutoPay>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "autopay")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<AutoPay>>>(),)!! 
  }

  override fun getAutoPaySchedule(autoPayId: Long): Flow<AutoPay> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "autopay/${"$autoPayId".encodeURLPath()}")
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<AutoPay>>(),)!! 
  }

  override suspend fun createAutoPaySchedule(payload: AutoPayPayload) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "autopay")
        }
        setBody(payload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun updateAutoPaySchedule(
    autoPayId: Long,
    payload: AutoPayUpdatePayload,
    command: String,
  ) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "autopay/${"$autoPayId".encodeURLPath()}")
        command?.let{ parameter("command", "$it") }
        }
        setBody(payload) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun deleteAutoPaySchedule(autoPayId: Long, command: String) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "autopay/${"$autoPayId".encodeURLPath()}")
        command?.let{ parameter("command", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun pauseAutoPaySchedule(autoPayId: Long, command: String) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "autopay/${"$autoPayId".encodeURLPath()}")
        command?.let{ parameter("command", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override suspend fun resumeAutoPaySchedule(autoPayId: Long, command: String) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "autopay/${"$autoPayId".encodeURLPath()}")
        command?.let{ parameter("command", "$it") }
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }

  override fun getAutoPayHistory(autoPayId: Long, limit: Int): Flow<Page<AutoPayHistory>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "autopay/${"$autoPayId".encodeURLPath()}/history")
        limit?.let{ parameter("limit", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<Page<AutoPayHistory>>>(),)!! 
  }

  override fun getUpcomingPayments(clientId: Long, limit: Int): Flow<List<UpcomingPayment>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "autopay/upcoming-payments")
        clientId?.let{ parameter("clientId", "$it") }
        limit?.let{ parameter("limit", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<List<UpcomingPayment>>>(),)!! 
  }

  override fun getAutoPayStatistics(clientId: Long): Flow<AutoPayStatisticsResponse> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "autopay/statistics")
        clientId?.let{ parameter("clientId", "$it") }
        } 
        }
    return _helper.request(_httpClient, _ext, typeInfo<Flow<AutoPayStatisticsResponse>>(),)!! 
  }
}

public class _AutoPayServiceProvider : ClassProvider<AutoPayService> {
  override fun create(_ktorfit: Ktorfit): AutoPayService = _AutoPayServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createAutoPayService(): AutoPayService = _AutoPayServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
